import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Injectable()
export class UuidInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has('skipUUId') && request.headers.get('skipUUId') === 'true') {
      const modifiedRequest = request.clone({
        headers: request.headers.delete('skipUUId')
      });
      return next.handle(modifiedRequest);
    } else {
      let uuid = sessionStorage.getItem('appUUID');
      if (!uuid) {
        uuid = uuidv4();
        sessionStorage.setItem('appUUID', uuid);
      }
      const modifiedRequest = request.clone({
        setHeaders: {
          'X-Request-ID': uuid
        }
      });
      return next.handle(modifiedRequest);
    }
  }
}
